export const getSpartanProductSectionHeaderTracking = (prefix: string) => ({
  header: `${prefix}-header`,
  eyebrow: `${prefix}-eyebrow`,
  title: `${prefix}-title`,
  description: `${prefix}-description`,
});
